import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Beacon, SCBOneDevice } from "../../../api/models";
import { BaseCard } from "../../BaseCard";

export interface AboutCardProps {
  beacon: Beacon | SCBOneDevice;
  deviceType?: "beacon" | "scb-one";
}

export function AboutCard({ beacon, deviceType }: AboutCardProps) {
  const { t } = useTranslation();

  return (
    <BaseCard title={t("beacon:about-this-device")} allowScroll={true}>
      <AboutTable beacon={beacon} deviceType={deviceType} />
    </BaseCard>
  );
}

interface AboutTableProps {
  beacon: Beacon | SCBOneDevice;
  deviceType?: "beacon" | "scb-one";
}

const AboutTable = ({ beacon, deviceType = "beacon" }: AboutTableProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <table className="about-device-card-table">
      <tbody>
        <tr className="about-device-card-row">
          <td className="about-device-card-col-a">{t("beacon:thing-name")}</td>
          <td className="about-device-card-col-b">
            {deviceType === "beacon"
              ? (beacon as Beacon).beaconId || "-"
              : (beacon as SCBOneDevice).id || "-"}
          </td>
        </tr>
        <tr className="about-device-card-row">
          <td className="about-device-card-col-a">ICCID</td>
          <td className="about-device-card-col-b">{beacon.iccid || "-"}</td>
        </tr>
        <tr className="about-device-card-row">
          <td className="about-device-card-col-a">
            {t("beacon:hardware-version")}
          </td>
          <td className="about-device-card-col-b">{beacon.hwv || "-"}</td>
        </tr>
        <tr className="about-device-card-row">
          <td className="about-device-card-col-a">
            {t("beacon:firmware-version")}
          </td>
          <td className="about-device-card-col-b">{beacon.fwv || "-"}</td>
        </tr>
        <tr className="about-device-card-row">
          <td className="about-device-card-col-a">
            {t("translations:organization")}
          </td>
          <td
            className={`about-device-card-col-b ${
              beacon.org?.name ? "pointer" : ""
            }`}
            onClick={() => {
              if (beacon.org?.id || beacon.org) {
                history.push(`/organizations/${beacon.org?.id}`);
              }
            }}
          >
            {beacon.org?.name ? <u>{beacon.org?.name}</u> : "-"}
          </td>
        </tr>
        {deviceType === "beacon" && (
          <>
            <tr className="about-device-card-row">
              <td className="about-device-card-col-a">
                {t("translations:construction-project")}
              </td>
              <td
                className={`about-device-card-col-b ${
                  (beacon as Beacon).project?.name ? "pointer" : ""
                }`}
                onClick={() => {
                  if ((beacon as Beacon).project?.name) {
                    history.push(`/construction-projects?beacons`, {
                      selectedId: (beacon as Beacon).project.id,
                    });
                  }
                }}
              >
                {(beacon as Beacon).project?.name ? (
                  <u>{(beacon as Beacon).project?.name}</u>
                ) : (
                  "-"
                )}
              </td>
            </tr>
            <tr className="about-device-card-row">
              <td className="about-device-card-col-a">
                {t("translations:construction-site")}
              </td>
              <td
                className={`about-device-card-col-b ${
                  (beacon as Beacon).site?.name ? "pointer" : ""
                }`}
                onClick={() => {
                  if ((beacon as Beacon).site?.name) {
                    history.push(`/construction-projects?beacons`, {
                      selectedId: (beacon as Beacon).site.id,
                    });
                  }
                }}
              >
                {(beacon as Beacon).site?.name ? (
                  <u>{(beacon as Beacon).site?.name}</u>
                ) : (
                  "-"
                )}
              </td>
            </tr>
          </>
        )}
      </tbody>
    </table>
  );
};
